<template>
    <k-page v-cloak>
        <template v-slot:header>
            <profile-header/>
        </template>
        <k-container size="lg" class="pb-20 mt-8">
            <div v-if="!$root.$data.investorProfile.active" class="mb-3">
                <k-alert v-if="!$root.$data.investorProfile.hasCompletedVerificationStep">
                    <template slot="text">{{ $t('thankYouRegister') }}</template>
                    <template slot="description">{{ $t('activateAccount') }}
                    </template>
                </k-alert>
                <k-alert v-if="$root.$data.investorProfile.hasCompletedVerificationStep">
                    <template slot="text">{{ $t('thankYouSubmission') }}</template>
                    <template slot="description">{{ $t('thankYouSubmissionDescription') }}</template>
                </k-alert>
            </div>

            <div v-if="!$root.$data.investorProfile.active" class="mb-6">
                <account-activation
                    :verification-steps="waitingVerificationSteps"
                    @handle-step="handleActivationStep"
                />
            </div>

         <div v-if="$root.$data.investorProfile.active && !$root.$data.investorProfile.focusGroupUser" class="mb-6">
           <template>
             <k-alert>
               <template slot="text">{{ $t('We Have a New Look for You') }}</template>
               <template slot="description">
                 {{ $t('We’re excited to share that Kilde has a new look and feel! Our website has been updated with a fresh, modern design to make your experience with us even more seamless and enjoyable. ') }}<br>
                 {{ $t('Our new look will be available to all accredited investors shortly.') }}
               </template>
             </k-alert>
           </template>
         </div>


             <div class="mb-3" v-if="$root.$data.investorProfile.accounts.length > 1">
                                <div class="flex justify-between items-center">
                                    <a-radio-group v-model="selectedCurrency" v-on:change="refresh" button-style="solid">
                                        <a-radio-button v-for="account in $root.$data.investorProfile.accounts" :key="account.currencyCode"
                                                        v-bind:value="account.currencyCode">
                                            {{ account.currencyCode }}
                                        </a-radio-button>
                                    </a-radio-group>
                                     <a-button type="primary" v-if="!$root.$data.investorProfile.vwoFeatures.goBackToReact.goBackToReactButtonHide" @click="this.$goBackToNewPlatform">Go back to new UI</a-button>
                                </div>
             </div>

            <investor-summary
                v-if="data.investorSummary"
                :investor-summary="data.investorSummary"
                @wallet="viewWallet()"
                @invest="viewTranches()"
            />

            <outstanding-investments
                v-if="!loading"
                :items="settled.items"
                @view="view"
            />

            <commited-investments
                v-if="!loading"
                :items="subscribed.items"
                @unsubscribe="unsubscribe"
                @view="view"
            />

            <reserved-investments
                v-if="!loading && reserved.items.length"
                :items="reserved.items"
                @cancel="cancelReservation"
                @approve="approveReservation"
            />

            <repaid-investments
                v-if="!loading"
                :items="paid.items"
                @view="view"
            />
        </k-container>
    </k-page>
</template>

<script>
import ProfileHeader from '@investor/components/profile/ProfileHeader'
import OutstandingInvestments from '@product-common/components/investor/OutstandingInvestments'
import InvestorSummary from '@product-common/components/investor/InvestorSummary'
import CommitedInvestments from '@product-common/components/investor/CommitedInvestments'
import RepaidInvestments from '@product-common/components/investor/RepaidInvestments'
import AccountActivation from '@product-common/components/investor/AccountActivation'
import _ from 'lodash'
import ReservedInvestments from "../../../common/components/investor/ReservedInvestments.vue";

export default {
    components: {
        ReservedInvestments,
        ProfileHeader,
        OutstandingInvestments,
        CommitedInvestments,
        RepaidInvestments,
        InvestorSummary,
        AccountActivation
    },
    created() {

    },
    data() {
        return {
            verificationSteps: [
                {
                    title: 'Investor verification',
                    description: 'In order to confirm, whether you qualify for investment with Kilde, please fill in this questionnaire',
                    step: 'QUESTIONNAIRE',
                    action: 'Verify',
                    route: '/status-verification',
                    analyticsEvent: {
                        category: 'verification',
                        action: 'verificationStart'
                    }
                },
                {
                    title: 'Proof of Accreditation',
                    description: 'Upload documents so we can verify your investor accreditation status',
                    step: 'PROOF_OF_ACCREDITATION',
                    route: '/poi-upload',
                    action: 'Verify',
                    analyticsEvent: {
                        category: 'POI',
                        action: 'poiStart'
                    }
                },
                {
                    title: 'Phone verification',
                    description: 'In order to setup 2FA',
                    step: 'PHONE_VERIFICATION',
                    action: 'Verify',
                    route: '/profile-phone-verification'
                },
                {
                    title: 'Second factor authentication',
                    description: 'Secure your account',
                    step: 'SECOND_FACTOR_AUTHENTICATION',
                    action: 'Setup',
                    route: '/settings?tab=2FA Setup',
                    analyticsEvent: {
                        category: 'authentication',
                        action: 'authenticationTwoFactotStart'
                    }
                },
                {
                    title: 'Personal details',
                    description: 'Provide additional personal info',
                    step: 'PERSONAL_DETAILS',
                    action: 'Verify',
                    route: '/profile-personal-details'
                },
                {
                    title: 'Proof of address',
                    description: 'Upload documents so we can verify your identity',
                    step: 'DOCUMENTS',
                    route: '/document-verification',
                    action: 'Verify',
                    analyticsEvent: {
                        category: 'adress',
                        action: 'adressStart'
                    }
                },
                {
                    title: 'Identity verification',
                    description: 'Upload documents so we can verify your identity',
                    step: 'VERIFF',
                    route: '/veriff',
                    action: 'Verify',
                    analyticsEvent: {
                        category: 'documents',
                        action: 'verificationDocumentsStart'
                    }
                },
                {
                    title: 'Identity verification',
                    description: 'Upload documents so we can verify your identity',
                    step: 'IDENTITY_VERIFICATION',
                    route: '/veriff',
                    action: 'Verify',
                    analyticsEvent: {
                        category: 'documents',
                        action: 'verificationDocumentsStart'
                    }
                },
                {
                    title: 'Accept terms',
                    description: 'Please read and accept our Terms of use and Privacy policy to activate account.',
                    step: 'ACCEPT_TERMS',
                    route: '/accept-terms',
                    action: 'Accept terms',
                },
            ],
            selectedCurrency: this.$root.$data.investorProfile.accounts[0].currencyCode,
            data: {
                investorSummary: null,
                paymentScheduleSummary: null
            },
            paid: {
                items: []
            },
            subscribed: {
                items: []
            },
            reserved: {
                items: []
            },
            settled: {
                items: []
            },
            loading: false,
        }
    },
    computed: {
        waitingVerificationSteps() {
            return _.filter(this.verificationSteps, stepDefinition => {
                return _.includes(this.$root.$data.investorProfile.waitingVerificationSteps, stepDefinition.step)
            })
        }
    },
    async mounted() {
        await this.refresh()
    },
    methods: {
        async refresh() {
            this.loading = true
            try {
                this.data = await this.$post('dashboard', {currencyCode: this.selectedCurrency})
                this.subscribed = await this.$post('portfolio/subscribed', {currencyCode: this.selectedCurrency})
                this.settled = await this.$post('portfolio/settled', {currencyCode: this.selectedCurrency})
                this.paid = await this.$post('portfolio/paid', {currencyCode: this.selectedCurrency})
                this.reserved = await this.$post('portfolio/reserved', {currencyCode: this.selectedCurrency})
            } finally {
                this.loading = false
            }
        },
        async unsubscribe(trancheUuid) {
            await this.$post('tranche/unsubscribe', {trancheUuid})
            await this.refresh()
            await this.$fetchInvestorProfile()
        },
        async view(trancheUuid) {
            this.$router.push({name: 'tranche-invest', params: {trancheUuid: trancheUuid}})
        },
        async cancelReservation(trancheUuid) {
            await this.$post(`tranche/${trancheUuid}/cancel-reservation`);
            this.$message.success('Reservation cancelled');
            await this.refresh()
            await this.$fetchInvestorProfile()
        },
        async approveReservation(trancheUuid) {
            try {
                await this.$post(`tranche/${trancheUuid}/settle-reservation`);
                this.$message.success('Reservation processed successfully');
                await this.refresh()
                await this.$fetchInvestorProfile()
            } catch (e) {
                this.$message.error('Couldn`t process reservation');
            }
        },
        async viewWallet() {
            this.$router.push({name: 'wallet'})
        },
        async viewTranches() {
            this.$router.push({name: 'tranche-listing'})
        },
        handleActivationStep(step) {
            if (step.analyticsEvent) {
                this.$trackGAEvent(step.analyticsEvent.category, step.analyticsEvent.action);
            }
            this.$router.push(step.route)
        }
   },
 }

</script>

